import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import MarkerClusterGroup from 'react-leaflet-cluster'
import { useContext, useRef, useState, useEffect } from 'react'
import { MapContainer, TileLayer, LayersControl, ZoomControl } from 'react-leaflet'

import './worldMap.scss'
import { AuthContext } from '@contexts/Auth'
import { CustomMarker } from './CustomMarker'
import RefreshIcon from '@mui/icons-material/Refresh'
import { LandingPageProjectInfo } from '@models/projects.model'
import { ProjectSelectionBox } from '@components/customized/projectSelectionBox'


const geolib = require('geolib')

export const WorldMap = () => {
	const [positionOrig] = useState([22.351346, 114.155856])
	const { BaseLayer } = LayersControl
	const [zoomLevel] = useState(11)
	const mapRef = useRef<any>(null)
	const [projectSelect, setProjectSelect] = useState(null)
	const { state, dispatch } = useContext(AuthContext)
	const projects: LandingPageProjectInfo[] = state.landingPageProjects

	const [maxBound, setMaxBound] = useState<[[number, number], [number, number]]>([
		//south westnavigate
		[21.8, 113.3],
		//north east
		[22.9, 115.1],
	])

	useEffect(() => {
		if (state.organizationInfo.map_config.maxBounds) {
			setMaxBound(state.organizationInfo.map_config.maxBounds)
		}
	}, [state])

	const HK_Polygon = [
		{ latitude: 22.29275, longitude: 114.152968 },
		{ latitude: 22.288302, longitude: 114.172713 },
		{ latitude: 22.297594, longitude: 114.203699 },
		{ latitude: 22.269955, longitude: 114.261465 },
		{ latitude: 22.246363, longitude: 114.261675 },
		{ latitude: 22.192809, longitude: 114.309147 },
		{ latitude: 22.193445, longitude: 114.201671 },
		{ latitude: 22.261456, longitude: 114.110349 },
		{ latitude: 22.296641, longitude: 114.110913 },
		{ latitude: 22.296403, longitude: 114.149197 },
	]

	const KWL_Polygon = [
		{ latitude: 22.342296, longitude: 114.177 },
		{ latitude: 22.351663, longitude: 114.227171 },
		{ latitude: 22.287826, longitude: 114.248286 },
		{ latitude: 22.290367, longitude: 114.222538 },
		{ latitude: 22.305932, longitude: 114.203312 },
		{ latitude: 22.290288, longitude: 114.170738 },
		{ latitude: 22.299261, longitude: 114.151598 },
		{ latitude: 22.321813, longitude: 114.150568 },
		{ latitude: 22.348964, longitude: 114.184728 },
	]

	const IS_Polygon = [
		{ latitude: 22.347536, longitude: 113.879645 },
		{ latitude: 22.352299, longitude: 114.045812 },
		{ latitude: 22.313555, longitude: 114.066756 },
		{ latitude: 22.257008, longitude: 114.104865 },
		{ latitude: 22.191538, longitude: 114.196532 },
		{ latitude: 22.191061, longitude: 114.307723 },
		{ latitude: 22.150524, longitude: 114.306823 },
		{ latitude: 22.147662, longitude: 113.889947 },
		{ latitude: 22.214424, longitude: 113.818534 },
		{ latitude: 22.33261, longitude: 113.874408 },
	]

	const markersSubDivision = (projects: LandingPageProjectInfo[] | []) => {
		if (projects.length) {

			let hk_markers = []
			let kwl_markers = []
			let nt_markers = []
			let is_markers = []

			if (projects.length) {
				for (let i = 0; i < projects.length; i++) {
					const position = { lat: projects[i]['y_coord'], lng: projects[i]['x_coord'] }

					if(position.lat !== null && position.lng !== null){
						if (geolib.isPointInPolygon(position, HK_Polygon)) {
							projects[i]['district'] = 'HK'
							hk_markers.push(projects[i])
						} else if (geolib.isPointInPolygon(position, KWL_Polygon)) {
							projects[i]['district'] = 'KWL'
							kwl_markers.push(projects[i])
						} else if (geolib.isPointInPolygon(position, IS_Polygon)) {
							projects[i]['district'] = 'IS'
							is_markers.push(projects[i])
						} else {
							projects[i]['district'] = 'NT'
							nt_markers.push(projects[i])
						}
					}
				}
			}

			const createClusterCustomIcon = (cluster: {
				getAllChildMarkers: () => any
				getChildCount: () => any
			}) => {
				const clusterChildMarkers = cluster.getAllChildMarkers()

				let childrenName: any = []
				clusterChildMarkers.forEach((ele: any) => {
					childrenName.push(
						"<div class='cluster-tooltip-content'>" +
							'&#x2022;' +
							'&nbsp;' +
							ele.options.children.props.children.props.markerElem.display_name +
							'</div>',
					)
				})

				let newChildrenName = ''
				if (childrenName.length > 3) {
					let projectLeft = childrenName.length - 3
					newChildrenName =
						childrenName.slice(0, 3).join('') +
						`<div class='cluster-tooltip-content' style={font-size: 10px}>and ${projectLeft} other project(s)</div>`
				} else {
					newChildrenName = childrenName.join('')
				}
				return L.divIcon({
					html: `
                  <span>
                      ${cluster.getChildCount()}
                      <div class="cluster-tooltip">
                          ${newChildrenName}
                      </div>
                  </span>`,
					className: 'marker-cluster-custom',
					iconSize: L.point(40, 40, true),
				})
			}
			return (
				<>
					<MarkerClusterGroup
						spiderfyOnMaxZoom={false}
						iconCreateFunction={createClusterCustomIcon}
						showCoverageOnHover={false}
						key={'hk_markerCluster'}
						maxClusterRadius={490}
					>
						{hk_markers.map((markerElem: LandingPageProjectInfo) => {
							return <CustomMarker key={markerElem.id} markerElem={markerElem} projectId={markerElem.id} mapRef={mapRef} />
						})}
					</MarkerClusterGroup>
					<MarkerClusterGroup
						spiderfyOnMaxZoom={false}
						iconCreateFunction={createClusterCustomIcon}
						showCoverageOnHover={false}
						key={'kwl_markerCluster'}
						maxClusterRadius={490}
					>
						{kwl_markers.map((markerElem: LandingPageProjectInfo) => {
							return <CustomMarker key={markerElem.id} markerElem={markerElem} projectId={markerElem.id}  mapRef={mapRef} />
						})}
					</MarkerClusterGroup>
					<MarkerClusterGroup
						spiderfyOnMaxZoom={false}
						iconCreateFunction={createClusterCustomIcon}
						showCoverageOnHover={false}
						key={'nt_markerCluster'}
						maxClusterRadius={490}
					>
						{nt_markers.map((markerElem: LandingPageProjectInfo) => {
							return <CustomMarker key={markerElem.id} markerElem={markerElem} projectId={markerElem.id}  mapRef={mapRef} />
						})}
					</MarkerClusterGroup>
					<MarkerClusterGroup
						spiderfyOnMaxZoom={false}
						iconCreateFunction={createClusterCustomIcon}
						showCoverageOnHover={false}
						key={'is_markerCluster'}
						maxClusterRadius={490}
					>
						{is_markers.map((markerElem: LandingPageProjectInfo) => {
							return <CustomMarker key={markerElem.id} markerElem={markerElem} projectId={markerElem.id}  mapRef={mapRef} />
						})}
					</MarkerClusterGroup>
				</>
			)
		}
	}

	const handleResetMap = () => {
		setProjectSelect(null)
		if (mapRef.current) {
			mapRef.current.flyTo(positionOrig, zoomLevel, {duration : 1} )
		}
	}

	
	return (
		<MapContainer
			key={'map'}
			className={'map'}
			center={[positionOrig[0], positionOrig[1]]}
			zoom={zoomLevel}
			zoomControl={false}
			minZoom={11}
			maxZoom={19}
			scrollWheelZoom={true}
			maxBounds={maxBound}
			ref={mapRef} 
		>
			
			
			<LayersControl key={'layerControl'} position={'bottomright'}>
				<BaseLayer key={'satellite'} checked name={'Satellite'}>
					<TileLayer
						maxZoom={19}
						key={'tileLayerA'}
						attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
						url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
					/>
				</BaseLayer>

				<BaseLayer key={'Stadia.AlidadeSmooth'} name={'Light Street Map'}>
					<TileLayer
						maxZoom={19}
						key={'tileLayerB'}
						attribution='<a href="https://carto.com/" target="_blank">&copy; CARTO</a> <a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
						url="https://api.maptiler.com/maps/voyager/{z}/{x}/{y}.png?key=8Tc1UtC0Qagqfq6BFujn"
					/>
				</BaseLayer>
			</LayersControl>

			{projects && markersSubDivision(projects)}
			<ZoomControl position="bottomright" />

			<>
				{/* <ProjectSelectionBox projects={projects} mapRef={mapRef} setProjectSelect={setProjectSelect} projectSelect={projectSelect}/> */}
				<div className={'refresh-btn'} onClick={handleResetMap}>
					<RefreshIcon sx={{ color: '#FFFFFF' }} />
				</div>
				{/* <div className={"world-btn"}>
          <div className={"deflaut"} />
          <span>World</span>
        </div> */}
			</>
		</MapContainer>
	)
}
